<template>
    <div component="ContractDetail">
        <section class="header">
            <scroll-table :list="[contract.transform()]" :config="config"></scroll-table>
            <div class="buttons">
                <button @click="$emit('hideDetail')" color="ghost" size="icon" class="close">
                    <i class="material-icons">close</i>
                </button>
                <button @click="print" color="accent" size="icon" class="close">
                    <i class="material-icons">print</i>
                </button>
            </div>
        </section>

        <section ref="detail" class="detail">
            <div v-bar class="vb">
                <div>
                    <div class="contract" ref="contract" v-html="contract.text"></div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ScrollTable from '@/components/.global/ScrollTable/ScrollTable.vue';

export default {
    name: 'ContractDetail',

    components: {
        ScrollTable,
    },

    props: {
        contract: {
            type: Object,
            required: true,
        },

        config: {
            type: Array,
            required: true,
        },
    },

    methods: {
        print() {
            const printWindow = window.open('', 'PRINT', 'width=800, height=1000');
            printWindow.document.write('<html><head><title>Contract ' + this.contract.number + '</title>');
            printWindow.document.write('</head><body >');
            printWindow.document.write(this.contract.text);
            printWindow.document.write('</body></html>');
            printWindow.document.close(); // necessary for IE >= 10
            printWindow.focus(); // necessary for IE >= 10
            printWindow.print();
            printWindow.close();
            return true;
        },
    },
};
</script>

<style lang="less">
@import '~@variables';

[component='ContractDetail'] {
    height: 100%;

    section.header {
        .flex-row;
        height: 80px;

        .buttons {
            padding-right: 15px;
            display: flex;
            flex-wrap: wrap;
            flex-direction: row-reverse;

            button {
                margin: 0 0 5px 5px;
            }
        }
    }

    [component='TableHead'] {
        margin: 0;
    }

    .detail {
        height: ~'calc(100% - 80px)';

        @media (orientation: landscape) {
            height: ~'calc(100% - 75px)';
        }

        .contract {
            padding: 15px 15px 15px 0;
        }

        .frame {
            width: 100%;
            height: 100%;
            border-width: 0;
            padding: 0 25px 20px 25px;

            @media (orientation: landscape) {
                padding: 0;
            }
        }
    }

    [component='ScrollTable'] {
        width: 100%;
        padding-top: 8px;

        .container {
            padding-right: 0;
        }
    }

    [component='TableRow'] {
        margin-right: 0;
    }
}
</style>
